var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":"primary","size":"48"}},[(_vm.user && _vm.user.profilePicture)?_c('img',{attrs:{"alt":"Avatar","src":_vm.user.profilePicture}}):_c('span',{staticClass:"white--text text-h5"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }